<template>
    <div>
        <Layout>
            <div v-if="!isLoading" class="col-lg-12">
                <div class="position-absolute" style="top: -46px; right: 1rem; z-index: 10">
                    <div class="d-flex align-items-center justify-content-end">
                        <p class="mb-0 mr-2" style="font-size: 12px; color: #74788d">
                            {{ `${$t('managerForm.textDateTimeSync')}${formData?.published?.published_at ?? ''}` }}
                        </p>
                        <button
                            v-if="isShowButton"
                            :class="`btn btn-outline-${formData.is_a_changed ? 'danger' : 'warning'} btn-only-icon mr-2`"
                            style="padding-block: 7px"
                            :disabled="
                                [STATUS_FORM_LIST.CREATED, STATUS_FORM_LIST.UNPUBLISHED].includes(formData?.status) || formData.is_first_create
                            "
                            @click="onHandleTranformPage"
                        >
                            <i class="mdi mdi-web"></i>
                        </button>
                        <button
                            v-if="checkPermission('form.delete')"
                            class="btn btn-common btn-common-delete btn-outline-danger"
                            :disabled="[STATUS_FORM_LIST.RESERVING].includes(formData.status)"
                            @click="handleDeleteManagerForm({ id: $route.query.id })"
                        >
                            <i class="ri-delete-bin-2-line"></i>{{ $t('btn.delete') }}
                        </button>
                    </div>
                </div>
                <div class="card mb-0">
                    <div class="card-body" style="min-height: 100vh">
                        <b-tabs
                            :value="modelTab"
                            vertical
                            justified
                            nav-class="nav-tabs-custom cus-document"
                            active-nav-item-class="font-weight-bold"
                            content-class="p-3 text-muted"
                            @input="onInputTabChanged"
                            @activate-tab="onTabChanged"
                        >
                            <b-tab v-for="(tab, index) in TABS" :key="index" class="border-0" :disabled="tab.disabled" @click="onHandleCickTab">
                                <template v-slot:title>
                                    <span class="">{{ tab.name }}</span>
                                </template>
                                <div>
                                    <SettingBasic v-if="tab.id === 1" :dataForm="formData" />
                                    <SettingDesign ref="settingDesign" v-else-if="tab.id === 2" :dataForm="formData" />
                                    <SettingPage ref="settingPage" v-else-if="tab.id === 3" :dataForm="formData" />
                                    <PageSettingMailI
                                        ref="PageSettingMailI"
                                        v-else-if="tab.id === 4"
                                        :dataMailTemplate="formData.registration_email_template"
                                        :optionTemplate="templateSendList"
                                        :optionSenderMail="senderFormList"
                                        :isView="true"
                                    />
                                    <SettingSerialCode
                                        v-else-if="tab.id === 6"
                                        :dataForm="formData.setting_serial_code"
                                        :inforForm="formData"
                                        :isView="true"
                                        :tableImportConfig="CONFIG_TABLE_IMPORT"
                                        @callGetListSerial="onHandleGetListSerial"
                                    />
                                    <PrizeSerialCode
                                        v-else-if="tab.id === 7"
                                        ref="PrizeSerialCode"
                                        :dataPrizes="formData.serial_code_prizes"
                                        :inforLottery="formData.setting_lottery"
                                        :isView="true"
                                        :inforForm="formData"
                                        @onHandleSettingCalendar="eventSettingCalendar"
                                    />
                                    <SettingCalendar
                                        ref="settingCalendar"
                                        v-else-if="tab.id === 8"
                                        :dataPrizes="formData.serial_code_prizes"
                                        :infoPrizeCalendar="prizeCalendarInfo"
                                        :indexPrizeCalendar="prizeCalendarIndex"
                                        :inforLottery="formData.setting_lottery"
                                        :isView="true"
                                        :isActive="modelTab === index"
                                        :loading.sync="isCalendarDataLoading"
                                        @selectPrize="onCalendarPrizeSync"
                                    />
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                    <ModalListPreview
                        :formData="{ ...formData, forms: formData.campaign_forms, landing_pages: formData.campaign_lps }"
                        :config.sync="configModalListPrv"
                    />
                </div>
                <Footer>
                    <div v-if="!buttonEvent.eventEditPrizeSerialCode" style="display: grid; grid-template-columns: repeat(3, 1fr)">
                        <div class="d-flex align-items-center" style="gap: 0.7rem">
                            <button @click="handleCancel" class="btn btn-common-footer">
                                <i class="ri-list-check"></i>{{ $t('btn.backListForm') }}
                            </button>
                        </div>
                        <div class="text-center">
                            <button
                                v-if="!isPageType(ID_PAGE_TYPE.C)"
                                type="button"
                                class="btn btn-common-footer mr-2"
                                @click="() => (configModalListPrv.model = true)"
                            >
                                <i class="ri-link-m"></i>{{ $t('pageCampaign.listLinkLPAndForm') }}
                            </button>
                            <template v-if="!isPageType(ID_PAGE_TYPE.C)">
                                <button
                                    v-if="checkPermission('form.analytics')"
                                    type="button"
                                    :class="`btn btn-common-footer mr-2 ${[STATUS_FORM_LIST.RESERVING].includes(formData.status) ? 'disabled_cursor' : ''}`"
                                    :disabled="[STATUS_FORM_LIST.RESERVING].includes(formData.status)"
                                    @click="handleToGo('/manager-form/analytics', formData)"
                                >
                                    <i class="ri-line-chart-line"></i>{{ $t('landingPage.settingBasic.analytics') }}
                                </button>
                                <button
                                    href="javascript:void(0)"
                                    :class="`btn btn-common-footer mr-2 ${[STATUS_FORM_LIST.RESERVING].includes(formData.status) ? 'disabled_cursor' : ''}`"
                                    :disabled="[STATUS_FORM_LIST.RESERVING].includes(formData.status)"
                                    @click="handleToGo('/manager-form/advanced', formData)"
                                >
                                    <i class="ri-mail-line"></i>{{ $t('managerForm.settingAdvanced.btnAdvanced') }}
                                </button>
                            </template>
                            <template class="d-flex justify-content-between w-100" v-if="![STATUS_FORM_LIST.RESERVING].includes(formData.status)">
                                <button
                                    v-if="[STATUS_FORM_LIST.PUBLISHING].includes(formData.status) && checkPermission('form.edit')"
                                    href="javascript:void(0)"
                                    class="btn btn-only-icon btn-outline-primary mr-2"
                                    style="min-width: 36px"
                                    @click="handleOpenModalSettingDate()"
                                >
                                    <i class="ri-calendar-line mr-0"></i>
                                </button>
                                <button
                                    v-if="
                                        ![STATUS_FORM_LIST.PUBLISHING].includes(formData.status) &&
                                        !formData.is_first_create &&
                                        checkPermission('form.edit')
                                    "
                                    href="javascript:void(0)"
                                    :class="`btn btn-common btn-warning ${![STATUS_FORM_LIST.CREATED, STATUS_FORM_LIST.UNPUBLISHED].includes(formData.status) ? 'action__record' : ''}`"
                                    @click="handleOpenModalSettingDate()"
                                >
                                    <i class="ri-global-line"></i>{{ $t('managerForm.list.settingDatePublish') }}
                                </button>
                            </template>
                            <template v-if="![STATUS_FORM_LIST.CREATED, STATUS_FORM_LIST.UNPUBLISHED].includes(formData.status)">
                                <button
                                    v-if="[STATUS_FORM_LIST.RESERVING].includes(formData.status) && checkPermission('form.edit')"
                                    href="javascript:void(0)"
                                    class="btn btn-common btn-secondary mr-2"
                                    @click="handleCancelNowBooking(formData)"
                                >
                                    {{ $t('managerForm.list.cancelDateNowBooking') }}
                                </button>
                                <button
                                    v-if="[STATUS_FORM_LIST.PUBLISHING].includes(formData.status) && checkPermission('form.edit')"
                                    href="javascript:void(0)"
                                    class="btn btn-common btn-danger"
                                    @click="handleCancelPublish()"
                                >
                                    <i class="ri-indeterminate-circle-line"></i>{{ $t('managerForm.list.cancelPublishForm') }}
                                </button>
                            </template>
                        </div>
                        <div class="text-right" v-if="$route.query.id">
                            <button
                                v-if="checkPermission('form.edit')"
                                type="button"
                                @click="handleOpenSaveTemp"
                                class="btn btn-common-footer mr-2"
                                :disabled="[STATUS_FORM_LIST.RESERVING].includes(formData.status)"
                            >
                                <i class="ri-download-line"></i>{{ $t('managerForm.saveTemporarily') }}
                            </button>
                            <button :class="`btn btn-common-footer mr-2`" @click="onHandleOpenPreview">
                                <i class="ri-eye-line"></i>{{ $t('btn.preview') }}
                            </button>
                            <button
                                v-if="checkPermission('form.register')"
                                type="submit"
                                @click="onHandleCopy"
                                class="btn btn-common-footer mr-2"
                                :disabled="[STATUS_FORM_LIST.RESERVING].includes(formData.status)"
                            >
                                <i class="ri-file-copy-2-line"></i>{{ $t('btn.copy') }}
                            </button>
                            <button
                                v-if="checkPermission('form.edit')"
                                type="submit"
                                @click="handleGoTo"
                                class="btn btn-common btn-primary"
                                :disabled="[STATUS_FORM_LIST.RESERVING].includes(formData.status)"
                            >
                                <i class="ri-edit-box-line"></i>{{ $t('btn.edit') }}
                            </button>
                        </div>
                    </div>
                    <div v-else :style="`display: grid; grid-template-columns: 1fr`">
                        <div class="text-center">
                            <button type="button" class="btn btn-common-cancel" @click="onCancelSerialPrize">
                                {{ $t('btn.cancel') }}
                            </button>
                        </div>
                    </div>
                </Footer>
                <ModalCopyForm
                    :dataForm="formData"
                    :mailInfor="inforMailForm"
                    :masterCampaign="listDataMasterCampaign"
                    :config="configModalCopyForm"
                />
                <ModalSettingDatePublish
                    v-if="this.configModalSettingDatePublish.model"
                    :currentRowSettingDate="formData"
                    :configModalSettingDatePublish="configModalSettingDatePublish"
                    :screen="`detail`"
                    @update-get-list="getDetail()"
                />
                <ModalTemporarily :configModal="configModalTemporarily" @save="handleSaveTemporarily" />
                <ModalPreviewForm v-if="configModalPrvForm.model" :formData="formData" :prvFormConfig="configModalPrvForm" />
            </div>
            <div class="d-flex justify-content-center" v-else>
                <LoadingIcon />
            </div>
            <div
                v-if="isCalendarDataLoading"
                style="
                    position: fixed;
                    inset: 0;
                    background: rgba(255, 255, 255, 0.7);
                    z-index: 9999;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                "
            >
                <LoadingIcon />
            </div>
        </Layout>
    </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Footer from '@/components/Footer/main.vue';
import SettingBasic from './components/setting-basic/main.vue';
import SettingDesign from './components/setting-design/main.vue';
import SettingPage from './components/setting-page/main.vue';
import SettingSerialCode from '../components/setting-serial-code/main.vue';
import PrizeSerialCode from '../components/prize-serial-code/main.vue';
import SettingCalendar from '../components/setting-calendar/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import ModalCopyForm from './components/modal-copy/main.vue';
import ModalListPreview from '@/views/pages/campaign/view/components/ModalListPreview/main.vue';
import PageSettingMailI from '@/views/pages/phase2/manager-form/components/setting-page/components/page-setting-mail-i.vue';
import ModalSettingDatePublish from '../components/modal-setting-date-publish/main.vue';
import ModalTemporarily from '../components/modal-temporarily/main.vue';
import ModalPreviewForm from '@/views/pages/phase2/manager-form/components/modal-preview-form/main.vue';

import { checkPermission, onHandleShowConfirm, getInfoUserLocalStorage } from '@/utils/handlers';
import {
    TABS,
    TAB_NAME,
    initForm,
    configs,
    STATUS_FORM_LIST,
    OPTION_PUBLIC_END_FORM,
    onHandleTabForm,
    ID_PAGE_TYPE,
    initInputCalendar
} from '../constants';
import { createIdEventRangeDate } from '@/views/pages/phase2/manager-form/components/setting-calendar/constants';
import { handleDataResponse, handleGetListSerial, onHandleTemporarily } from '../handlers';
import { masterMethods, managerFormMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';
import { configModalCopyForm } from './components/modal-copy/constants';
import { STATUS_MAIL } from '@/views/pages/phase2/manager-form/email/constants.js';
import { configModalTemporarily } from '../components/modal-temporarily/constants';
import { isRolePartner } from '@/views/pages/require/handlers.js';
import { CONFIG_TABLE_IMPORT } from '@/views/pages/phase2/manager-form/components/setting-serial-code/constants';
import { mapState } from 'vuex';

export default {
    name: 'ManagerFormView',
    page: {
        title: 'キャンペーン一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        Footer,
        SettingBasic,
        SettingDesign,
        SettingPage,
        SettingSerialCode,
        PrizeSerialCode,
        SettingCalendar,
        LoadingIcon,
        ModalCopyForm,
        ModalListPreview,
        PageSettingMailI,
        ModalSettingDatePublish,
        ModalTemporarily,
        ModalPreviewForm
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('form.view')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            CONFIG_TABLE_IMPORT,
            STATUS_MAIL,
            ID_PAGE_TYPE,
            TABS: TABS(),
            STATUS_FORM_LIST,
            OPTION_PUBLIC_END_FORM,
            formData: initForm(),
            configModalListPrv: configs.configModalListPrv,
            configModalSettingDatePublish: configs.configModalSettingDatePublish,
            configModalPrvForm: configs.configModalPrvForm,
            configModalTemporarily,
            isLoading: false,
            configModalCopyForm,
            listDataMasterCampaign: [],
            inforMailForm: null,
            modelTab: 0,
            senderFormList: [],
            templateSendList: [],
            prizeCalendarInfo: null,
            prizeCalendarIndex: 0,
            arrIdPrizeDaily: [],
            isCalendarDataLoading: false
        };
    },
    computed: {
        ...mapState({
            ...mapState('managerForm', ['buttonEvent'])
        }),

        isShowButton() {
            const { eventEditBlock, eventEditBlockStep2 } = this.buttonEvent;
            return !eventEditBlock && !eventEditBlockStep2;
        },

        formPublicUrl() {
            let domain = this.formData?.custom_domain?.domain || process.env.VUE_APP_DOMAIN_FORM;
            if (this.formData?.is_a_changed && this.formData?.published_domain) {
                domain = this.formData.published_domain;
            }
            return `https://${domain}/form/${this.formData?.url_public}`;
        },

        isPageType() {
            return (pageType) => this.formData?.page_type?.id === pageType;
        }
    },
    methods: {
        checkPermission,
        ...masterMethods,
        ...managerFormMethods,

        async onTabChanged(newTabIndex, prevTabIndex, bvEvent) {
            if (newTabIndex === this.modelTab) return;
            let { eventEditPrizeSerialCode } = this.buttonEvent;
            const hasUnsavedChanges = eventEditPrizeSerialCode;
            if (hasUnsavedChanges) {
                bvEvent.preventDefault();
                const confirmExitSettingForm = await onHandleShowConfirm({
                    title: '',
                    text: 'ページ設定内容がまだ保存されない可能性がありますが、移動してもよろしいですか。'
                });
                if (confirmExitSettingForm) {
                    if (eventEditPrizeSerialCode) {
                        this.$refs.PrizeSerialCode[0].onHandleCancel();
                        this.$refs.PrizeSerialCode[0].handleCancelPrizeBlock();
                    }
                    this.modelTab = newTabIndex;
                } else {
                    this.modelTab = prevTabIndex;
                }
            } else {
                this.modelTab = newTabIndex;
            }
        },

        handleCancel() {
            this.$router.push({
                path: '/manager-form/list'
            });
        },

        handleToGo(url, row) {
            if ([STATUS_FORM_LIST.RESERVING].includes(row.status)) return;
            this.$router.push({ path: url, query: { id: row.id } });
        },

        handleGoTo() {
            this.$router.push({
                path: '/manager-form/edit',
                query: {
                    id: this.$route.query.id,
                    tab: this.modelTab
                }
            });
        },

        onInputTabChanged(tabIndex) {
            this.modelTab = tabIndex;
            if (tabIndex === 1) {
                this.$nextTick(() => {
                    this.$refs.settingDesign[0].refreshCodeMirror();
                });
            }
        },

        onHandleCickTab() {
            if (this.$refs?.settingPage[0]) this.$refs.settingPage[0].onHandleCloseSettingBlock();
            this.onHandleCalendarMounted();
        },

        async handleDeleteManagerForm(payload) {
            const confirmDelete = await onHandleShowConfirm({
                title: 'フォームとデータを削除します。よろしいですか。',
                text: '',
                icon: 'warning',
                cancelButtonText: 'キャンセル'
            });
            if (confirmDelete) {
                try {
                    const response = await this.deleteManagerForm(payload);
                    if (response.code !== 200) return;
                    this.$router.push({ path: '/manager-form/list' }).then(() => {
                        showMessage(response.code, this.$bvToast, ' 削除されました。');
                    });
                } catch (error) {
                    console.log('error', error);
                }
            }
        },
        handleOpenModalSettingDate() {
            this.configModalSettingDatePublish.title = this.$t('managerForm.list.settingDatePublish');
            this.configModalSettingDatePublish.model = true;
        },
        async handleCancelPublish() {
            const confirm = await onHandleShowConfirm({
                text: `フォーム「(${this.formData.id}) ${this.formData.name}」の公開を停止します。本当によろしいですか。`
            });
            if (confirm) {
                try {
                    const dataRes = await this.stopPublishNow({ id: this.formData.id });
                    if (dataRes?.code !== 200) {
                        showMessage(dataRes.code, this.$bvToast, this.$t('system.error'));
                        return;
                    }
                    this.getDetail();
                } catch (error) {
                    console.log('error', error);
                }
            }
        },
        async handleCancelNowBooking(row) {
            const confirm = await onHandleShowConfirm({ text: `フォーム「(${row.id}) ${row.name}」の公開予約を解除します。本当によろしいですか。` });
            if (confirm) {
                try {
                    const dataRes = await this.stopPublishNow({ id: row.id });
                    if (dataRes?.code !== 200) {
                        showMessage(dataRes.code, this.$bvToast, this.$t('system.error'));
                        return;
                    }
                    this.getDetail();
                } catch (error) {
                    console.log('error', error);
                }
            }
        },

        async getDetail() {
            if (!this.$route?.query?.id) return;
            this.isLoading = true;
            try {
                const response = await this.getDetailManagerForm(this.$route.query.id);
                handleDataResponse(this.formData, response);
                this.TABS = onHandleTabForm(this.formData?.page_type?.id);
                if (response?.is_first_create) {
                    this.TABS = this.TABS.map((tab) => ({ ...tab, disabled: tab.id === 1 ? false : true }));
                }
                this.formData.registration_email_template = {
                    ...this.formData.registration_email_template,
                    invite: {
                        ...this.formData.registration_email_template.invite,
                        template:
                            this.templateSendList.find((item) => item.id === response.registration_email_template?.invite?.template?.id) || null,
                        email_sender: response.registration_email_template?.invite?.email_sender?.id
                            ? this.senderFormList.find((item) => item.id === response.registration_email_template.invite.email_sender.id)
                            : this.senderFormList[0]
                    }
                };
                await this.onHandleGetListSerial();
                await Promise.all(
                    this.formData.serial_code_prizes.map(async (prize) => {
                        try {
                            const data = await this.onGetDailyLimitsPrize(prize);
                            prize.prize_date_event.daily_limits = (data || []).map(initInputCalendar);
                        } catch {
                            prize.prize_date_event.daily_limits = [];
                        }
                    })
                );
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
            this.onHandleCalendarMounted();
        },

        async onHandleGetListSerial() {
            await handleGetListSerial(this);
        },

        onCancelSerialPrize() {
            this.$refs.PrizeSerialCode[0].onHandleCancel();
        },

        async onGetDailyLimitsPrize(evt) {
            if (!evt?.id || this.arrIdPrizeDaily.includes(evt.id)) return [];
            let payload = {
                form_id: this.formData.id,
                prize_id: evt.id
            };
            try {
                const dataRes = await this.getDailyLimitsPrizeForm(payload);
                if (dataRes?.code !== 200) {
                    showMessage(dataRes.code, this.$bvToast, dataRes.message);
                    return;
                }
                this.arrIdPrizeDaily.push(evt.id);
                return dataRes.data;
            } catch (error) {
                showMessage(error.code, this.$bvToast, error.message);
            }
        },

        async onCalendarPrizeSync(evt) {
            this.isCalendarDataLoading = true;
            let dataDailyEvent = await this.onGetDailyLimitsPrize(evt);
            this.isCalendarDataLoading = false;
            dataDailyEvent = dataDailyEvent?.map((e) => initInputCalendar(e)) || [];
            let eventDailyLocal = [];
            if (evt.prize_date_event?.daily_limits?.length > 0) {
                eventDailyLocal = evt.prize_date_event.daily_limits.map((e) => {
                    e.id = createIdEventRangeDate({
                        startStr: e.startStr,
                        endStr: e.endStr
                    });
                    return e;
                });
            }

            this.formData.serial_code_prizes = this.formData.serial_code_prizes.map((p) => {
                const isSelected = p.make_id === evt.make_id || (p.id && p.id === evt.id);
                return {
                    ...p,
                    extension: {
                        ...p.extension,
                        is_selected: isSelected
                    }
                };
            });

            this.prizeCalendarInfo = {
                ...evt,
                extension: {
                    ...evt.extension,
                    is_selected: true
                },
                prize_date_event: {
                    ...evt.prize_date_event,
                    daily_limits: eventDailyLocal?.length > 0 ? eventDailyLocal : dataDailyEvent || []
                }
            };

            this.prizeCalendarIndex++;
        },

        async eventSettingCalendar(evt) {
            await this.onCalendarPrizeSync(evt);
            this.modelTab = this.TABS.findIndex((item) => item.name === TAB_NAME.page_setting_calendar_lottery);
            this.onHandleCalendarMounted();
        },

        onHandleCalendarMounted() {
            this.$nextTick(() => {
                this.$refs?.settingCalendar[0]?.$refs.CalendarFull.getApi().render();
                this.$refs?.settingCalendar[0]?.onHandleGoToDate();
            });
        },

        onHandleCopy() {
            this.configModalCopyForm.model = true;
        },

        async getMasterCampaign() {
            try {
                let query = 'all/campaigns';
                if (isRolePartner()) {
                    query += `?has[partner]=${getInfoUserLocalStorage().partner_id}`;
                }
                const dataRes = await this.listMaster(query);
                this.listDataMasterCampaign = dataRes;
            } catch (error) {
                console.log('error', error);
            }
        },

        async getMailDetailForm() {
            try {
                const dataGet = await this.getDetailSettingEmail(this.$route.query.id);
                this.inforMailForm = dataGet.data ?? null;
            } catch (error) {
                console.log('error', error);
            }
        },
        returnStatusMailLabel(status) {
            return STATUS_MAIL.find((item) => item.value === status)?.label;
        },

        async onGetListAllEmailFrom() {
            this.isLoading = true;
            try {
                let dataRes = await this.getListAllEmailFrom();
                this.senderFormList = dataRes?.map((item) => ({
                    ...item,
                    label_mail: `${item.email_address} - ${item.title} - 認証ステータス: ${this.returnStatusMailLabel(item.status_domain)}`
                }));
            } catch (error) {
                console.log('error', error);
            }
        },

        async onGetListAllTemplateMail() {
            try {
                let dataRes = await this.getListAllTemplateMail();
                this.templateSendList = dataRes;
            } catch (error) {
                console.log('error', error);
            }
        },

        handleOpenSaveTemp() {
            this.configModalTemporarily.model = true;
        },

        onHandleRemoveId(pageForm) {
            if (pageForm) {
                delete pageForm.page_inputs?.id;
                delete pageForm.page_confirms?.id;
                delete pageForm.page_completes?.id;
                if (pageForm.page_inputs?.blocks) {
                    pageForm.page_inputs.blocks = pageForm.page_inputs.blocks.map((blockItem) => {
                        if (blockItem.option_values) {
                            blockItem.option_values = blockItem.option_values.map((item) => {
                                delete item.id;
                                delete item.form_block_id;
                                return item;
                            });
                        }
                        return blockItem;
                    });
                }
                if (pageForm.page_completes?.blocks) {
                    pageForm.page_completes.blocks = pageForm.page_completes.blocks.map((blockItem) => {
                        return blockItem;
                    });
                }
            }
            return pageForm;
        },

        async handleSaveTemporarily(evt) {
            onHandleTemporarily(evt, this);
        },

        onHandleOpenPreview() {
            if ([ID_PAGE_TYPE.I, ID_PAGE_TYPE.B].includes(this.formData?.page_type?.id)) {
                this.configModalPrvForm.model = true;
            } else {
                window.open(`/manager-form/preview?id=${this.$route.query.id}&type=${this.formData?.page_type?.alias}`, '_blank');
            }
        },

        onHandleTranformPage() {
            window.open(this.formPublicUrl, '_blank');
        }
    },
    async mounted() {
        await this.onGetListAllEmailFrom();
        await this.onGetListAllTemplateMail();
        this.getDetail();
        if (this.$route.query.tab !== undefined) {
            this.modelTab = Number(this.$route.query.tab);
        }
        this.getMasterCampaign();
        this.getMailDetailForm();
    }
};
</script>

<style lang="scss"></style>
